import configs from './config';
import API from '../helpers/api';
export default new API(configs['branding.url']);
